import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Accordion, Col, Nav, Tab} from "react-bootstrap";
import {useLocation} from "react-router";

import CourseCardItems from "../../components/CourseCardItems";
import TestsCardList from "../../c../../components/TestsCardList";
import Loader from "../../components/Loader";

import ApiEndpoint from "../../services/api.endpoint.service";
import {
    ContentResponse,
    CourseResponse,
    SearchResponse,
    TestResultResponse,
} from "../../services/api.response.service";
import {IRootState} from "../../redux/states";
import Main from "../../redux/actions/main.action";
import {BaseState, StateKeys} from "../../redux/states/main.state";
import {AppState, getLanguage, getLanguageByDefault, ResourceTypes} from "../../services/app.service";
import {TestResponse} from "../../services/api.response.service";
import ClassesCardVList2 from "../../components/ClassesCardVList2";
import ContentProvidersCardList from "../../components/ContentProvidersCardList";
import {Mixpanel} from "../../services/mixpanel";

const MainSearchResult = () => {
    // @ts-ignore

    const getLanguage = getLanguageByDefault();
    const location = useLocation();
    const query = new URLSearchParams(location.search).get("q");
    const dispatch = useDispatch();
    const state = useSelector((state: IRootState) => state.main);
    // const [showTestDetails, setShowTestDetails] = useState<TestResponse>();
    const [showCourseDetails, setShowCourseDetails] = useState<CourseResponse>();
    // const [showTopicDetails, setShowTopicDetails] = useState<CourseResponse>();
    const testResults: BaseState<Array<TestResultResponse>> =
        state[StateKeys.CLASS_TEST_RESULTS];

    const generalSearch: BaseState<SearchResponse> =
        state[StateKeys.GENERAL_SEARCH];
    const topics = state[StateKeys.CLASS_COURSE_TOPICS];
    const [contents, setContents] = useState<ContentResponse[] | []>([]);
    const dataPersist = state[StateKeys.DATA_PERSIST];
    // const courses: BaseState<Array<CourseResponse>, ClassResponse> = state[
    //   StateKeys.CLASS_COURSES
    // ];
    const collapseTitles = ["Contents", "Classes", "Content_Providers", "Tests"];

    useEffect(() => {
        if (
            generalSearch.pageState !== AppState.LOADED ||
            query !== data.search_text
        ) {
            dispatch(
                Main.getPageObjectData({
                    stateKey: StateKeys.GENERAL_SEARCH,
                    apiEndpoint: ApiEndpoint.GENERAL_SEARCH(query ?? ""),
                })
            );
        }
    }, [query]);


    const {data, pageState} = generalSearch;

    const handleContentTabChangeAction = (title: string) => {
        // Mixpanel.track('Content Access - ' + title, {
        //     'with': ecampus_id ? "Auth" : "Guest",
        //     'content_id': content?.id,
        //     'content_name': content?.title,
        //     'class_id': theClass?.id,
        //     'class_name': theClass?.name,
        //     'user_id': currentUser.id,
        // });

    };


    const handleDefaultActiveKey = () => {

        if (data.contents && data.contents.length > 0) {
            return "contents";
        } else if (data.classes && data.classes.length > 0) {
            return "classes";
        } else if (data.content_providers && data.content_providers.length > 0) {
            return "learningPartners";
        } else if (data.tests && data.tests.length > 0) {
            return "tests";
        } else {
            return "contents";
        }

        // return  content?.has_read
        //     ? "read"
        //     : content?.has_practice
        //         ? "practice"
        //         : content?.content_resources.filter(
        //             (item) => item.type === ResourceTypes.VIDEO
        //         ).length
        //             ? "watch"
        //             : content?.content_resources.filter(
        //                 (item) => item.type === ResourceTypes.AUDIO
        //             ).length
        //                 ? "listen"
        //                 : content?.has_test
        //                     ? "test"
        //                     : "discuss";
    }

    return (
        <>
            <div className="content-page scroller-hide">
                <>
                    <h5 className="pt-3 pb-3">
                        {getLanguage.searchResults}
                        <span className="text-capitalize"> "{query}"</span>
                    </h5>
                    {pageState !== AppState.LOADING && (
                        <>
                            <div className="pb-5 mb-5">

                                <Tab.Container defaultActiveKey={''}>
                                    <Tab.Content>
                                        <Tab.Pane eventKey={''}>
                                            <Tab.Container
                                                defaultActiveKey={handleDefaultActiveKey()}
                                            >
                                                <div className="user-tabing">
                                                    <Nav
                                                        as="ul"
                                                        variant="pills"
                                                        className="d-flex align-items-center justify-content-start course-tab p-0 m-0 border-bottom"
                                                    >
                                                        {data.contents_count > 0 && (
                                                        <Nav.Item
                                                            as="li"
                                                            className=" col-12 col-sm-2 p-0 "
                                                        >
                                                            <Nav.Link
                                                                eventKey="contents"
                                                                role="button"
                                                                className="text-center p-3"
                                                                onClick={() => handleContentTabChangeAction('contents')}
                                                            >
                                                                {getLanguage.topics} ({data.contents_count})
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                        )}

                                                        {data.classes_count > 0 && (
                                                        <Nav.Item
                                                            as="li"
                                                            className="col-12 col-sm-2 p-0"
                                                        >
                                                            <Nav.Link
                                                                eventKey="classes"
                                                                role="button"
                                                                className="text-center p-3"
                                                                onClick={() => handleContentTabChangeAction('classes')}
                                                            >
                                                                {getLanguage.classes} ({data.classes_count})
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                        )}

                                                        {data.content_providers_count > 0 && (
                                                        <Nav.Item
                                                            as="li"
                                                            className="col-12 col-sm-2 p-0"
                                                        >
                                                            <Nav.Link
                                                                eventKey="learningPartners"
                                                                role="button"
                                                                className="text-center p-3"
                                                                onClick={() => handleContentTabChangeAction('learningPartners')}
                                                            >
                                                                {getLanguage.learningPartners} ({data.content_providers_count})

                                                            </Nav.Link>
                                                        </Nav.Item>
                                                        )}

                                                        {data.tests_count > 0 && (
                                                        <Nav.Item
                                                            as="li"
                                                            className="col-12 col-sm-2 p-0"
                                                        >
                                                            <Nav.Link
                                                                eventKey="tests"
                                                                role="button"
                                                                className="text-center p-3"
                                                                onClick={() => handleContentTabChangeAction('tests')}
                                                            >
                                                                {getLanguage.tests} ({data.tests_count})
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                        )}

                                                    </Nav>
                                                </div>
                                                <Col sm={12} className="pt-3">

                                                    <Tab.Content>
                                                        <Tab.Pane
                                                            eventKey="practice"
                                                            className="content-page">

                                                        </Tab.Pane>
                                                        <Tab.Pane
                                                            eventKey="contents"
                                                            className="content-page">
                                                            {data.contents_count > 0 && (
                                                            <CourseCardItems
                                                                courses={data.contents}
                                                                setCourseDetails={setShowCourseDetails}
                                                            />
                                                            )}
                                                        </Tab.Pane>

                                                        <Tab.Pane
                                                            eventKey="classes"
                                                            className="content-page">
                                                            {data.classes_count > 0 && (
                                                            <ClassesCardVList2
                                                                data={data.classes}
                                                                state={pageState}
                                                            />
                                                            )}


                                                        </Tab.Pane>

                                                        <Tab.Pane
                                                            eventKey="learningPartners"
                                                            className="content-page">

                                                            {data.content_providers_count > 0 && (
                                                            <ContentProvidersCardList
                                                                data={data.content_providers}
                                                                state={pageState}
                                                            />
                                                            )}

                                                        </Tab.Pane>

                                                        <Tab.Pane
                                                            eventKey="tests"
                                                            className="content-page">
                                                            {data.tests_count > 0 && (
                                                            <TestsCardList
                                                                tests={data.tests}
                                                                // setShowTestDetails={setShowTestDetails}
                                                                // getTestResults={getTestResults}
                                                            />
                                                            )}


                                                        </Tab.Pane>

                                                    </Tab.Content>
                                                </Col>
                                            </Tab.Container>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Tab.Container>


                            </div>
                        </>
                    )}

                    {pageState !== AppState.LOADING ||
                        (query && <Loader noCard imageLoader/>)}{" "}
                </>
            </div>
        </>
    );
};

export default MainSearchResult;
